<section class="login-block">
  <!-- Container-fluid starts -->
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <!-- Authentication card start -->
        <form *ngIf="!twoFactorStep" novalidate #loginForm="ngForm" (submit)="loginForm.valid && submitLogin()">
          <div class="auth-box card">
            <div class="card-block">
              <div class="row m-b-20">
                <div class="col-md-12">
                  <h3 class="text-center">{{'auth.lock.title'|translate}}</h3>
                </div>
              </div>
              <div class="form-group form-primary">
                <label class="float-label">{{'auth.signin.username'|translate}}</label>
                <input type="text" name="userName" #userName="ngModel" [(ngModel)]="login.username" class="form-control" readonly>
                <span class="form-bar"></span>
                <div class="messages text-danger" *ngIf="userName.invalid && userName.dirty && userName.errors?.required">{{'errors.required'|translate}}</div>
              </div>
              <div class="form-group form-primary">
                <label class="float-label">{{'auth.signin.password'|translate}}</label>
                <input type="password" name="password" #password="ngModel" class="form-control" [(ngModel)]="login.password" required minlength="6">
                <span class="form-bar"></span>
                <div class="messages text-danger" *ngIf="password.invalid && password.dirty && password.errors?.required">{{'errors.required'|translate}}</div>
                <div class="messages text-danger" *ngIf="password?.errors?.minlength">{{'auth.signin.password.minlength'|translate}}</div>
              </div>
              <div class="row m-t-25 text-start">
                <div class="col-12">
                  <div class="checkbox-fade fade-in-primary">
                    <label>
                      <input type="checkbox" value="" [(ngModel)]="login.rememberMe" name="rememberMe" >
                      <span class="cr"><i class="cr-icon fa fa-check txt-primary"></i></span>
                      <span class="text-inverse">{{'auth.signin.remember_me'|translate}}</span>
                    </label>
                  </div>
                  <div class="forgot-phone text-end float-right">
                    <a [routerLink]="['/forgot-password']" class="text-end f-w-600"> {{'auth.link.forgot_password'|translate}}</a>
                  </div>
                </div>
              </div>
              <div class="row m-t-30">
                <div class="col-md-12">
                  <button [disabled]="!loginForm.valid" [ngClass]="{'btn-disabled': !loginForm.valid, 'disabled': !loginForm.valid}" type="submit" class="btn btn-primary btn-md btn-block text-center m-b-20 ripple light">{{'auth.unlock.button'|translate}}</button>
                </div>
              </div>
              <hr/>
              <div class="row">
                <div class="col-md-6">
                  <a href="https://www.urbansofa.nl/">
                    <span class="text-inverse text-start m-b-0">https://www.urbansofa.nl/</span>
                  </a>
                </div>
                <div class="col-md-6 text-end">
                  <a [routerLink]="'/login'">
                    <span class="text-inverse text-start m-b-0">{{'auth.link.login'|translate}}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </form>
        <form *ngIf="twoFactorStep" novalidate #loginForm="ngForm" (submit)="loginForm.valid && submitLogin()">
          <div class="text-center">
            <img class="header-logo" src="../../../assets/images/urbansofa_logo_white.png" alt="logo.png">
          </div>
          <div class="auth-box card">
            <div class="card-block">
              <div class="row m-b-20">
                <div class="col-md-12">
                  <h3 class="text-center">{{'auth.verificatie'|translate}}</h3>
                </div>
              </div>
              <div class="form-group form-primary">
                <label class="float-label">{{'auth.enter.code'|translate}}</label>
                <input type="text" name="verifyCode" #verifyCode="ngModel" [(ngModel)]="login.auth_code" class="form-control" minlength="6" maxlength="6" required autofocus>
                <span class="form-bar"></span>
                <div class="messages text-danger" *ngIf="verifyCode.invalid && verifyCode.dirty && verifyCode.errors?.required">{{'errors.required'|translate}}</div>
              </div>
              <div class="row m-t-30">
                <div class="col-md-12">
                  <button [disabled]="!loginForm.valid || isSubmitting" [ngClass]="{'btn-disabled': !loginForm.valid, 'disabled': !loginForm.valid}" type="submit" class="btn btn-primary btn-md btn-block text-center m-b-20 ripple light">{{'auth.to_confirm'|translate}}</button>
                </div>
              </div>
            </div>
          </div>
        </form>
        <!-- end of form -->
      </div>
      <!-- end of col-sm-12 -->
    </div>
    <!-- end of row -->
  </div>
  <!-- end of container-fluid -->
</section>
